import api from "../../adapter/base";
import {useQuery,useMutation,useQueryClient,useInfiniteQuery} from "react-query";

const fetchBestDeals=async (page=1,paginate=12)=>{
    const bestDeals=await api.get(`/best-deals?page=${page}&paginate=${paginate}`);
    return bestDeals?.data?.data;
}

export const useBestDeals=(page)=>{
    // return useQuery(["bestDeals",page],fetchBestDeals);
    const {data,isError,error,fetchNextPage,hasNextPage,isFetchingNextPage,isLoading} = useInfiniteQuery(
        ['bestDeals'],
        ({pageParam=page})=>fetchBestDeals(pageParam),{
            getNextPageParam:(lastPage,pages)=> {
                return lastPage.length === 12 ? pages.length + 1 : undefined
            },
            retry:3
        }
    );
    const bestDeals=data?.pages.flat() || []

    return {
        bestDeals,
        error:isError ? error.message : null,
        hasMore:hasNextPage,
        loadMore:fetchNextPage,
        isFetchingNextPage,
        isInitialLoad:isLoading
    }
}


const fetchDeal=async (id)=>{
    const res=await api.get(`/deals/${id}`);
    return res.data.data;
}


export const useBestDeal=(id)=>{
    return useQuery(["bestDeal",id],fetchDeal);
}


const storeBestDeal=async (bestDeal)=>{
    const res=await api.post(`/best-deals`,bestDeal);
    return res.data.data;
}


export const useStoreBestDeal=()=>{
    const client=useQueryClient();
    return useMutation(
        {
            mutationFn:storeBestDeal,
            onSuccess: (res) => {
                client.invalidateQueries("bestDeals")
            }
    }
    )
}


const updateBestDeal=async (bestDeal)=>{
    const res=await api.post(`/best-deals/${bestDeal.id}`, {...bestDeal,"_method":"put"});
    return res.data.data;
}


export const useUpdateBestDeal=()=>{
    const client=useQueryClient()
    return useMutation(
        {
            mutationFn:updateBestDeal,
            onSuccess:(res) => {
                client.invalidateQueries("bestDeals");
            }
        }
    )
}



const deleteBestDeal=async (id)=>{
    const bestDealToDelete=await api.delete(`/best-deals/${id}`);
    return true;
}


export const useDeleteBestDeal=()=>{
    const client=useQueryClient();
    return useMutation({
        mutationFn:deleteBestDeal,
        onSuccess:(res) => {
            client.invalidateQueries("bestDeals");
        }
})
}